module.exports = __webpack_public_path__ + "img/img-splash-loading-bg@2x.ff32ec15.png";